const EVENTS_PT = {
  accepted: "Oferta aceite pelo cliente",
  booking_auto_extended: "Prorrogação automática",
  booking_end: "Pedido de fim de reserva",
  booking_extension: "Pedido de prorrogação",
  break_repair: "Avarias significativas",
  break_repair_2: "Pequenas avarias",
  breakdown: "Avaria",
  breakdown_electric: "Avaria elétrica",
  breakdown_engine: "Avaria no motor",
  breakdown_mecanic: "Avaria mecânica",
  breakdown_other: "Outra avaria",
  canceled: "Cancelado",
  closed: "Fechado",
  confirmed: "Encomenda confirmada",
  damages_third_parties: "Pedido de indemnização legal",
  delay_in_delivery: "Atraso na entrega",
  deliveryOn: "Entrega em",
  document_compliance: "Conformidade de documentos",
  events: "{{count}} eventos",
  forgetting_extend: "Esqueceu-se de prorrogar",
  forgetting_recover: "Esqueceu-se de recuperar",
  from_date: "Início",
  hours_record: "Registo de horas",
  immobilisation: "Imobilização",
  incompetent_operator: "Operador incompetente",
  inventory: "Inventário",
  keys: "Chave/Código: perdida/não comunicada",
  machine_delivery: "Entrega",
  machine_retrieval: "Recolha",
  missing_accessory: "Acessório em falta",
  n1_control: "Controlo N1",
  n2_control: "Controlo N2",
  n3_control: "Controlo N3",
  no_show: "Entrega: Ausente",
  open: "Aberto",
  openEvents: "Eventos abertos",
  operator_change: "Mudança de operador",
  other: "Outro",
  other_delivery: "Outra entrega",
  other_request: "Outro pedido",
  quality_issue: "Equipamento em mau estado",
  retrievalOn: "Recolha em",
  robbery_accessory: "Roubo de acessório",
  robbery_article: "Roubo de máquina",
  sent: "Pedido recebido",
  to_date: "Fim",
  undeclared_use: "Utilização não declarada",
  validated: "Pedido de reserva validado",
  weather: "Mau tempo",
  wrong_machine: "Erro de equipamento",
  wrong_reclassification: "Seleção incorreta da máquina",
} as const;

export default EVENTS_PT;
